import React from 'react'
import { Outlet, Navigate } from 'react-router-dom'

export const PrivateWrapper = ({ auth: { isLoggedIn } }) => {
  return isLoggedIn ? <Outlet /> : <Navigate to="/" />;
};